import { canAccessExpansionFieldRoles, INVENTORY_ROLE_PATTERNS } from "./commercialRoleAccess";
import { canViewerPermission, getViewerEmailFromStorage } from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

export function materialsInventoryPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.MATERIALS_INVENTORY);
}

export function canAccessMaterialsInventory(viewerEmail) {
  if (!materialsInventoryPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (canViewerPermission(email, "canAccessMaterialsInventory", false)) return true;
  return canAccessExpansionFieldRoles(INVENTORY_ROLE_PATTERNS, email, { includeCoordinator: true });
}
